import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getDatumReports = async (token) => {
  const url = 'datum/reports'
  const data = await apiGet({ url, token })
  return data
}

const getDatumReportEmbed = async (token, id) => {
  const url = `datum/reports/${id}`
  const data = await apiGet({ url, token })
  return data
}

export function useDatumReports({ options } = {}) {
  const token = useContext(AuthContext)
  const queryFn = () => getDatumReports(token)
  const queryKey = 'datum-reports'
  return useQuery(queryKey, queryFn, { ...options })
}

export function useDatumReportEmbed({ id, options } = {}) {
  const token = useContext(AuthContext)
  const queryFn = () => getDatumReportEmbed(token, id)
  const queryKey = ['datum-report-embed', id]
  return useQuery(queryKey, queryFn, {
    enabled: !!id,
    staleTime: 30 * 60 * 1000, // 30 minutes
    ...options
  })
}
